import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from '@app/App.vue'
import router from '@app/router'
import plugins from '@app/plugins'

export function initApp() {
  const app = createApp(App)
  const pinia = createPinia()

  plugins.forEach(plugin => plugin(app))
  app.use(router)
  app.use(pinia)

  return app
}